module.exports = __webpack_public_path__ + "static/media/Simple-Line-Icons.0cb0b9c5.woff2";